var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"pl-0"},_vm._l((_vm.data),function(item,index){return _c('li',{key:index},[_c('span',{style:({ 'background-color': item.color })}),_vm._v("\n    "+_vm._s(item.label)+"\n  ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }